<div class="mt-4" *transloco="let t">
  <div [class]="gridClass()">
    @for (image of allImages(); track image.url) {
      <div class="group relative overflow-hidden rounded-md border border-gray-200" [class]="aspectClass()">
        <!-- `alt` com fallback: `StorageFile.name` é opcional, e quem passa uma URL já salva não o
             preenche. Sem o fallback o browser desenha o texto "undefined" ao lado da imagem
             quebrada, que é o que aparece quando o objeto do bucket não é público. -->
        <img [src]="image.url" [alt]="image.name || (t('image') | capitalize)" class="h-full w-full object-cover" />
        <!--
          Botão comum, NÃO `mat-icon-button`: o Material pinta `background-color: transparent` com a
          mesma especificidade de uma classe do Tailwind, então qual das duas vence depende da ordem
          das folhas de estilo. A versão anterior tinha ícone branco sobre esse fundo transparente e
          era literalmente invisível. Aqui o fundo é o do próprio elemento e não disputa com ninguém.

          Sempre visível, sem depender de hover: em tela de toque não existe hover para revelá-lo.
          `z-10` porque o `<img>` irmão ocupa a área inteira.
        -->
        <button
          type="button"
          class="absolute right-2 top-2 z-10 flex h-8 w-8 cursor-pointer items-center justify-center rounded-full border-2 border-white bg-red-400 text-white shadow-md transition-colors hover:bg-red-500"
          [matTooltip]="t('remove') | capitalize"
          [attr.aria-label]="t('remove') | capitalize"
          (click)="deleteImage(image)"
        >
          <!-- `!` no branco: o Material define `color` no `.mat-icon` e vence a classe do Tailwind. -->
          <mat-icon class="icon-size-5 text-white!" svgIcon="heroicons_outline:trash"></mat-icon>
        </button>
      </div>
    }

    @if (canAddMore()) {
      <label
        class="drop-zone flex cursor-pointer flex-col items-center justify-center gap-1 rounded-md border-2 border-dashed border-gray-300 transition-colors hover:border-primary"
        [class]="aspectClass()"
        [class.opacity-50]="isLoading()"
        [class.pointer-events-none]="isLoading()"
        [class.border-primary]="isDragging()"
        [class.bg-primary-50]="isDragging()"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)"
      >
        @if (isLoading()) {
          <mat-spinner diameter="32"></mat-spinner>
        } @else {
          <mat-icon class="text-gray-400">add_photo_alternate</mat-icon>
          <span class="text-xs text-gray-400 text-center px-1">{{ t('select-image') | capitalize }}</span>
        }
        <input type="file" class="hidden" [accept]="allowedExtensions" [disabled]="isLoading()" (change)="onFileSelected($event)" />
      </label>
    }
  </div>
</div>
